module.exports = __webpack_public_path__ + "media/images/pages/home_fausto_pic-e831f045b75d7f4858968af1b6def976.jpg";